<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :items="items"
    v-model="model"
    name="tipo"
    placeholder="Tipo"
    :menu-props="menuProps"
    clearable
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.text }}</span>
      </v-chip>

      <span v-if="index === 1" class="text-body-2 font-weight-regular">
        (+{{ model.length - 1 }})
      </span>
    </template>
  </v-select>
</template>

<script>
import { mixin } from "./mixin";

const _config = {
  mod: "categories",
};

const _data = {
  loading: true,
  model: null,
  items: [
    {
      text: "Residencial",
      value: "Terreno",
    },
    {
      text: "Comercial",
      value: "Terreno Comercial",
    },
  ],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
  },
  watch: {
    $route(v) {
      this.model = v.query.tipo ? v.query.tipo.split(",") : null;
    },
  },
  mounted() {
    if (this.$route.query.tipo) this.model = this.$route.query.tipo.split(",");
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  mixins: [mixin],
};
</script>
